/* @flow */

import * as React from 'react';

import {colors, getColorNameFromTagColor} from 'shells/colors';
import {Popover} from 'shells/popover';

import {TokenizedItemWrapper} from './tokenized-item-wrapper';

import './truncated-items.module.css';

type Props = {|
    renderRow: (value: Object) => React.Node | string,
    isTokenized: boolean,
    value: Object[],
|};

TruncatedItems.defaultProps = {
    isTokenized: true,
};

export function TruncatedItems(props: Props) {
    const [isShowingMoreEntities, setShowingMoreEntities] = React.useState<boolean>(false);
    const showMoreRef = React.useRef(null);

    const handleMouseOver = () => {
        setShowingMoreEntities(true);
    };

    const handleMouseOut = () => {
        setShowingMoreEntities(false);
    };

    if (props.value.length <= 2) {
        return props.value.map<React.Node>((row, index) =>
            props.isTokenized ? (
                <TokenizedItemWrapper
                    // eslint-disable-next-line react/no-array-index-key
                    key={index}
                    colorName={row.color ? getColorNameFromTagColor(row.color) : undefined}
                >
                    {props.renderRow(row)}
                </TokenizedItemWrapper>
            ) : (
                props.renderRow(row)
            )
        );
    }

    const firstRow = props.isTokenized ? (
        <TokenizedItemWrapper
            colorName={
                props.value[0] && props.value[0].color
                    ? getColorNameFromTagColor(props.value[0].color)
                    : undefined
            }
        >
            {props.renderRow(props.value[0])}
        </TokenizedItemWrapper>
    ) : (
        props.renderRow(props.value[0])
    );

    return (
        <div>
            {firstRow}
            <div styleName={props.isTokenized ? 'show-more--tokenized' : 'show-more'}>
                <span onMouseOver={handleMouseOver} onMouseOut={handleMouseOut} ref={showMoreRef}>
                    and {props.value.length - 1} more…
                </span>
            </div>
            {isShowingMoreEntities ? (
                <Popover anchor={showMoreRef.current}>
                    <ul styleName='truncated-list'>
                        {props.value.slice(1).map((row, index) => (
                            <div
                                // eslint-disable-next-line react/no-array-index-key
                                key={index}
                                styleName={row.color ? 'color-named-value' : undefined}
                                style={{
                                    backgroundColor: colors[getColorNameFromTagColor(row.color)],
                                }}
                            >
                                {props.renderRow(row)}
                            </div>
                        ))}
                    </ul>
                </Popover>
            ) : undefined}
        </div>
    );
}
